import { useState } from "react";
import SingleSelect from "../../../components/SingleSelect";
import { useGetAssignUsersQuery } from "../../../store/services/assigningUsers";
import { Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

export default function ReportFilters({ users, loading, onGenerate }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [leadType, setLeadType] = useState();

  const leadTypeOptions = [
    { label: "Lead", value: "lead" },
    { label: "Calling Data", value: "calling_data" },
    { label: "Both", value: null },
  ];

  const handleSubmit = () => {
    if (!selectedUser) {
      return alert("Please select user");
    }

    if (startDate && !startDate.isValid()) {
      return alert("Please enter a valid Start date");
    }

    if (endDate && !endDate.isValid()) {
      return alert("Please enter a valid End date");
    }

    console.log({
      startDate: startDate?.format("YYYY-MM-DD"),
      endDate: endDate?.format("YYYY-MM-DD"),
    });

    onGenerate({
      userId: selectedUser?._id,
      leadType: leadType && leadType?.value ? leadType?.value : null,
      startDate,
      endDate,
    });
  };

  const { data } = useGetAssignUsersQuery("");

  return (
    <div className="bg-white rounded-xl border p-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="text-sm font-medium block mb-2">User</label>

          <SingleSelect
            label=""
            options={data?.data}
            value={selectedUser}
            onChange={(newValue) => setSelectedUser(newValue)}
            getOptionLabel={(option) =>
              `${option.label} (${option.role?.replace("_", " ")})`
            }
            getOptionValue={(option) => option._id}
            onInputChange={() => {}} // required to avoid crash if not provided
            placeholder="Select User"
          />
        </div>

        <div>
          <label className="text-sm font-medium block mb-2">Lead Type</label>

          <SingleSelect
            label=""
            options={leadTypeOptions}
            value={leadType}
            onChange={(newValue) => setLeadType(newValue)}
            getOptionLabel={(option) => `${option.label}`}
            getOptionValue={(option) => option.value}
            onInputChange={() => {}}
            placeholder="Select Lead Type"
          />
        </div>
        {/* 
        <div>
          <label className="text-sm font-medium block mb-2">
            Start Date
          </label>

          <input
            type="date"
            value={startDate}
            onChange={(e) =>
              setStartDate(e.target.value)
            }
            className="w-full border rounded-lg px-3 py-2"
          />
        </div>

        <div>
          <label className="text-sm font-medium block mb-2">
            End Date
          </label>

          <input
            type="date"
            value={endDate}
            onChange={(e) =>
              setEndDate(e.target.value)
            }
            className="w-full border rounded-lg px-3 py-2"
          />
        </div> */}

        <div item xs={12} sm={6} md={3}>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 500,
              color: "#6b7280",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              mb: 0.7,
            }}
          >
            Start date
          </Typography>
          <DatePicker
            value={startDate}
            onChange={(v) => setStartDate(v)}
            sx={{ width: "100%" }}
            format="DD/MM/YYYY"
            slotProps={{ field: { size: "small" } }}
          />
        </div>

        <div item xs={12} sm={6} md={3}>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 500,
              color: "#6b7280",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              mb: 0.7,
            }}
          >
            End date
          </Typography>
          <DatePicker
            value={endDate}
            onChange={(v) => setEndDate(v)}
            sx={{ width: "100%" }}
            format="DD/MM/YYYY"
            slotProps={{ field: { size: "small" } }}
          />
        </div>

        <div className="flex items-end">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-black text-white px-4 py-2 rounded-lg"
          >
            {loading ? "Loading..." : "Generate Report"}
          </button>
        </div>
      </div>
    </div>
  );
}
